import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Dentist } from '../shared/interfaces/dentist.model';
import { PageDataScheduleTypes, PageDataTotalTypes } from '../shared/interfaces/page-data.enum';
import { PublicApiService } from '../shared/services/public-api.service';
import { PublicService } from '../shared/services/public.service';

@Component({
  selector: 'app-dentists',
  templateUrl: './dentists.component.html',
  styleUrls: ['./dentists.component.scss']
})
export class DentistsComponent implements OnInit, OnDestroy {

  private subscription!: Subscription;
  
  dentists!: Dentist[];
  selectedDentist!: Dentist;

  constructor(
    private publicService: PublicService,
    private publicApiService: PublicApiService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.subscription = new Subscription();    
  }

  ngOnInit(): void {
    this.getDentists();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private getDentists(): void {
    this.subscription.add(
      this.publicApiService.getDentistsByClinic()
        .pipe(filter(x => !!x || (x as []).length))
        .subscribe((x: any) => {
          this.dentists = x;
          this.setPageData();
          this.verifyNavegate();
        })
    );
  }

  private setPageData(): void {
    this.publicService.setPageDataTotal(
      PageDataTotalTypes.DENTISTS_TOTAL, this.dentists.length
    );
  }

  private verifyNavegate(): void {
    if (this.dentists.length === 1) {
      this.publicService.setPublicScheduleSelectedData(
        PageDataScheduleTypes.DENTIST_SCHEDULE_DATA,
        this.dentists[0]
      );
      this.navigate(0);
    }
    if(this.publicService.getDentist() && Number(this.publicService.getDentist()) > 0) {
      var dentist = this.dentists.find(x => x.id == this.publicService.getDentist())
      this.publicService.setPublicScheduleSelectedData(
        PageDataScheduleTypes.DENTIST_SCHEDULE_DATA,
        dentist
      );
      this.navigate(0);
    }
  }

  private navigate(timeout: number = 200): void {
    setTimeout(() => {
      this.router.navigate(['available-hours'], { relativeTo: this.activatedRoute})
    }, timeout);
  }

  public isSelected(dentistId: string): boolean {
    if (!this.selectedDentist) {
      return false;
    }
    return this.selectedDentist.id === dentistId;
  }

  public dentistSelectChanged(index: number): void {
    this.selectedDentist = this.dentists[index];
    this.publicService.setPublicScheduleSelectedData(
      PageDataScheduleTypes.DENTIST_SCHEDULE_DATA,
      this.selectedDentist
    );
    this.navigate();
  }
}
